<div *ngIf="pop" class="pop">
    <nirby-pop-player [context]="context" [campaign]="pop"></nirby-pop-player>
</div>
